<div class="progress my-2" style="position: relative;">
    <div class="progress-bar" *ngFor="let val of value" role="progressbar" [style.width]="val.width"
        [style.backgroundColor]="val.color" (mouseover)="showTooltip(val, $event)" (mouseleave)="hideTooltip()"
        style="position: relative;"></div>

    <div *ngIf="hoveredData" class="tooltip-content" [style.top.px]="tooltipY" [style.left.px]="tooltipX">
        <div><strong>Distribution</strong></div>
        <ng-container *ngFor="let key of getKeys(hoveredData.distribution)">
            <p><span>{{ key }} </span><span> {{ hoveredData.distribution[key] }}</span></p>
        </ng-container>
    </div>
</div>